import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import RelativeLink from "app/pages/.shared/RelativeLink";
import "./FaqSubCategory.scss";
import { sendTagOnFaqSubCategoryPage } from "app/utils/analytics";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const FaqSubCategory = ({ faqCategories = [] }) => {
	const param = useParams();
	const categoryId = param.categoryId;
	const subCategoryId = param.subCategoryId;

	const faqCategory =
		faqCategories?.find(faqCategory => {
			return faqCategory.id === categoryId;
		}) || {};

	const faqSubCategory = faqCategory?.subCategories?.find(faqCategory => {
		return faqCategory?.id === subCategoryId;
	});

	useEffect(() => {
		if (faqSubCategory) {
			sendTagOnFaqSubCategoryPage(faqSubCategory.name);
		}
	}, [faqSubCategory]);

	if (faqSubCategory) {
		return (
			<div className="faq-subcategory">
				<div className="faq-subcategory__name">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL}
						variantMD={TYPOGRAPHY_VARIANTS.XL5}
						isBold
						component="span"
					>
						{faqCategory.name} >{" "}
					</Typography>
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL}
						variantMD={TYPOGRAPHY_VARIANTS.XL5}
						isBold
						component="span"
						className="faq-subcategory__cat-name"
					>
						{faqSubCategory.name}
					</Typography>
				</div>
				<section>
					{faqSubCategory.articles.map(article => {
						return (
							<div key={article.id} className="faq-subcategory__article">
								<RelativeLink
									to={{
										pathname: `/faq/category/${faqCategory.id}/subcategory/${
											faqSubCategory.id
										}/article/${article.id}`,
									}}
								>
									{article.title}
								</RelativeLink>
							</div>
						);
					})}
				</section>
			</div>
		);
	}

	return null;
};

FaqSubCategory.propTypes = {
	faqCategories: PropTypes.array,
};

export default memo(FaqSubCategory);
